import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, RawActions, IEventFilter } from '@adage/ace-calendar';
import axios from 'axios';

import Dropdown from '../views/dropdown';
import { IWACEvent, InputOption, ICalendarReduxState } from '../classes';
import { selectFilterOption } from "../redux/actions/index";

interface DropdownComponentExternalProps {
    /**
     * This key is shared across the application, so MOBILE and DESKTOP filters should share the same keys.
     */
    filterKey: string;
    /**
     * This is the property to be compared on the IWACEvent object. For an example, tessVenueName.
     */
    propertyToCompare: string;
    /**
     * The label for the dropdown.
     */
    name: string;
    /**
     * The API endpoint to pull the options for this dropdown.
     */
    apiEndpoint: string;
    onChange?: (newInput: string) => any;
}

interface StateToProps {
    selectedItem: string;
}

interface DropdownComponentDispatchProps {
    updateFilter: (matched: string) => any;
}

type DropdownComponentProps = DropdownComponentDispatchProps & StateToProps & DropdownComponentExternalProps;

interface DropdownComponentState {
    options: Array<InputOption>;
}

class DropdownComponent extends React.Component<DropdownComponentProps, DropdownComponentState> {

    constructor(props: DropdownComponentProps) {
        super(props);

        this.state = {
            options: []
        };
    }

    componentWillMount() {
        axios.get(`/api/Calendar/${this.props.apiEndpoint}`).then(response => {
            const optionValues: Array<InputOption> = response.data.map(item => { return { text: item.text, value: item.value } });
            optionValues.unshift({ text: `All ${this.props.name}`, value: '' });

            this.setState({
                options: optionValues
            });
        }).catch(err => {
            console.log(err);
        });
    }

    onChange(newValue: string) {
        this.props.updateFilter(newValue);

        if (this.props.onChange) {
            this.props.onChange(newValue);
        }
    }

    render(): JSX.Element {
        return <Dropdown options={this.state.options} selected={this.props.selectedItem} onChange={this.onChange.bind(this)} name={this.props.name} />
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: DropdownComponentProps) {
    return {
        updateFilter: (matched: string) => {
            dispatch(selectFilterOption({
                filterKey: ownProps.filterKey, chosenValue: matched
            }));
        }
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: DropdownComponentExternalProps) {
    return {
        selectedItem: state.filterModel.dropdownOptions[externalProps.filterKey]
    }
}


export default connect<StateToProps, DropdownComponentDispatchProps>(mapStateToProps, mapDispatchToProps)(DropdownComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/dropdown.tsx